<template>
  <main v-if='home && home.extended'>
    <section v-once class='intro'>
      <big v-html='kirby.site.content.tagline.kirbytext'>What is on<br />your mind right<br />now?</big>
      <blobs />
    </section>
    <section v-once class='description'>
      <summary v-html='home.content.introduction.kirbytext' />
    </section>
    <topicals v-once :features='home.content.features.features' :page='home'/>
    <section v-once class='showcase'>
      <blobs />
      <section class='columns' v-for='(sets, index) in home.content.showcase.showcase' :key='index'>
        <aside v-for='(column,index) in sets.columns'  :key='index'>
          <template v-for='block in column.blocks'>
            <h2 v-if='block.type == "heading"'
                :key="block.id"
                v-html='block.content.text' />
            <figure v-if='block.type == "image"'>
              <img :src='kirby.pages.home.files[block.content.image[0]].src'>
            </figure>
            <div class='button-wrapper' v-if='block.type == "button" && block.content.link[0]'> 
              <router-link :to='pageFromUUID(block.content.link[0]).uri ? pageFromUUID(block.content.link[0]).uri : ""' class='larger-button' v-html='block.content.text' />
            </div>
            <summary v-if='block.type == "text"'
                     v-html='block.content.text' />
            <div class='playlist' v-if='block.type == "playlist"'>
              <summary v-html='block.content.text'/>
              <PlayList :stories='block.content.stories' />
            </div>
          </template>
        </aside>
      </section>
    </section>

    <section v-once class='donate'>
      <section class='columns'>
        <aside>
          <h1 v-html='home.content.donate_left_title.kirbytext' />
          <summary v-html='home.content.donate_left_text.kirbytext' />
          <small v-html='home.content.donate_left_smalltext.kirbytext' />
        </aside>
        <aside class='center'>
          <blockquote v-html='home.content.donate_right_largetext.kirbytext' />
          <div>
            <a target='_blank' :href='home.content.donate_right_button_url.value' class='larger-button' v-html='home.content.donate_right_button.kirbytext' />
          </div>
        </aside>
      </section>
    </section>

    <MainFooter v-once/>
  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  computed: {
    home: function() {
      if (this.kirby.page.uri == 'home') return this.kirby.page;
      return this.kirby.pages.home;
    }
  }
}
</script>


<style scoped>

  main {
    position: relative;
  }

  big {
    font-size: var(--huge);
    height: 3.5em;
    color: white;
    font-family: 'clarendon', serif;
    line-height: 1.125em;
    z-index: 1;
    text-align: center;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    top: -2rem;
    margin: auto;
    display: inline-block;
  }

  section {
    position: relative;
  }

  section.intro {
    height: var(--intro-height);
    position: relative;
  }

  section.description {
    background-color: var(--lightmint);
    max-width: var(--main-max-width);
    margin: auto;
    box-sizing: border-box;
    padding: 2.25rem 1.5rem;
    border-radius: 2rem;
    margin-top: -7rem;
    margin-bottom: 1rem;
    position: relative;
    z-index: 1;
  }

  section.showcase {
    width: 100%;
    overflow: hidden;
    padding-top: 12em;
    padding-bottom: 12em;
    position: relative;
  }

  section.showcase section.blobs {
    position: relative;
  }

  section.showcase section.blobs {
    position: absolute;
    top: 0;
    bottom: 0;
  }

  section section.columns {
    box-sizing: border-box;
    margin: auto;
    width: var(--main-max-width);
    display: flex;
    flex-direction: var(--columns-or-rows);
    gap: 2em;
    flex-basis: var(--half-or-not);
    padding: var(--main-padding);
  }

  section section.columns aside {
    box-sizing: border-box;
    display: flex;
    flex-direction: var(--columns-or-rows);
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
  }

  section section.columns aside.center {
    text-align: center;
  }

  section section.columns aside > * {
    box-sizing: border-box;
    width: 100%;
  }

  section.donate section.columns {

  }

  aside {
    box-sizing: border-box;
    width: var(--half-or-not);
    margin: auto;
  }

  section.showcase section.columns aside > h2 {
    text-align: center;
    color: white;
  }

  section section.columns aside > h2 {
    text-align: center;
    font-size: 3em;
    max-width: 10em;
    font-weight: normal;
  }

  section.showcase aside > summary {
    max-width: 25em;
    font-weight: normal;
  }

  section.showcase aside > summary {
    text-align: center;
    color: white;
  }

  aside > div.button-wrapper {
    text-align: center;
    margin-bottom: 2em;
  }

  aside a.larger-button {
    font-size: 1.25rem;
    display: inline-block;
    padding: 1.5em 2em 1.35em;
    line-height: 1;
    border-radius: 2em;
    font-family: 'value', sans-serif;
    background-color: #049bac;
    white-space: nowrap;
    color: white;
    margin: auto;
  }

  section p {
    max-width: 30em;
  }

  figure {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  figure img {
    width: 100%;
    max-height: 15rem;
    object-fit: contain;
  }

  summary {
    margin: auto;
  }

</style>

<style>
  section.description summary p {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  div.playlist {
    background-color: var(--lightmint);
    max-width: var(--main-max-width);
    box-sizing: border-box;
    padding: 1.25rem 3.25rem 3em;
    border-radius: 3rem;
    text-align: left;
  }

  div.playlist h2 {
    font-size: 3em;
    font-weight: lighter;
  }

  div.playlist summary {
    text-align: left;
  }
</style>
